export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does 4 Seasons Painting serve?",
    a: "We're based in Phoenix and cover the whole Valley — Scottsdale, Gilbert, Chandler, Mesa, Apache Junction, San Tan Valley, Florence, Casa Grande, Coolidge, Surprise, Sun City, Goodyear, Avondale, and Peoria. Travel is included in your estimate, so there are no surprise trip charges.",
  },
  {
    q: "How much does painting cost?",
    a: "It depends on square footage, how many coats and colors are involved, and how much prep the surfaces need. Every estimate is free and written down before any work starts — you'll know the full price up front, with no change orders unless you ask for something extra.",
  },
  {
    q: "What hours are you open?",
    a: "24 hours a day, 7 days a week. Call or message any time and we'll get back to you. We also schedule painting around your hours, including evenings and weekends for businesses that can't close during the day.",
  },
  {
    q: "Do you offer any discounts?",
    a: "Two. Refer a friend and you get a $100 gift card once their project is finished — there's no cap, so five referrals is five gift cards. Active-duty military and retired personnel always receive 10% off their project.",
  },
  {
    q: "How long does an exterior repaint take in Arizona?",
    a: "Most single-family homes take three to five days: one day for pressure washing and drying, one for crack repair and masking, and two or three for priming and two full coats. We'll give you a firm schedule with your estimate.",
  },
  {
    q: "What kind of paint do you use on Arizona exteriors?",
    a: "UV-resistant acrylics and elastomeric coatings rated for desert heat. Standard interior-grade or bargain exterior paint chalks and fades within a couple of Phoenix summers — the right coating holds its color for years and bridges hairline stucco cracks instead of splitting over them.",
  },
  {
    q: "Do I need to move my furniture before you paint inside?",
    a: "No. We move and cover furniture ourselves, mask floors and fixtures, and put everything back where it belongs when the job is done. Just clear personal items off shelves and countertops and we'll handle the rest.",
  },
  {
    q: "Do you do more than just painting?",
    a: "Yes. Along with interior and exterior painting we handle power washing, custom sun screens, seamless rain gutter installation, and custom pergolas and patio covers. Bundling them into one visit costs less than booking each separately.",
  },
];
